import React, { useContext } from "react";
import moment from "moment";
import { formatPrice, getSystemSettings, formatReportDate } from "../../../../functions/Functions";
import { SettingsContext } from "../../../../contexts/Settings";

const BranchExpenseReport = (props) => {
  const { reportData, componentRefExpense } = props;
  const { generalSettings } = useContext(SettingsContext);

  if (!reportData) return null;

  return (
    <div className="d-none">
      <div ref={componentRefExpense} className="fk-print-text_pos new-xsm-text text-capitalize" style={{ wordBreak: "break-word" }}>
        {/* Header section */}
        <div className="text-center mb-3">
          <p className="font-weight-bold xslg-text border-bottom border-top border-dark py-1 m-0">
            {reportData.header?.report_name || 'Branch Expense Report'}
          </p>
        </div>

        {/* Info Table */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border border-dark border-bottom-0 text-center font-weight-bold py-1">
            {reportData.header?.company_name || getSystemSettings(generalSettings, "siteName")}
          </p>
          <p className="mb-0 border border-dark border-bottom-0 text-center font-weight-bold py-1">
            POS Profile : {reportData.header?.pos_profile || "-"}
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Voucher</span>
            <span className="text-right px-1 py-1" style={{ width: "50%", wordBreak: "break-word" }}>
              {Array.isArray(reportData.header?.voucher) ? reportData.header.voucher.join(', ') : (reportData.header?.voucher || "-")}
            </span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Branch Name</span>
            <span className="text-right px-1 py-1" style={{ width: "50%", wordBreak: "break-word" }}>{reportData.header?.branch_name || "-"}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Date</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{reportData.header?.date || "-"}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Printed Date</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{reportData.header?.printed_date || moment().format("YYYY-MM-DD HH:mm:ss")}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Opening Shift</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{reportData.header?.opening_shift || "-"}</span>
          </p>
        </div>

        {/* Expense Summary */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border fk-print-text_pos border-dark text-center font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Expense Summary
          </p>
          <p className="mb-0 d-flex w-100 fk-print-text_pos border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "30%" }}>Description</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "25%" }}>Pay Type</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "20%" }}>Type</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "25%" }}>Amount</span>
          </p>
          {Array.isArray(reportData?.summary) && reportData.summary.length > 0 ? reportData.summary.map((item, index) => {
            return (
              <p key={index} className="mb-0 d-flex fk-print-text_pos w-100 border border-dark border-top-0">
                <span className="border-right border-dark px-1 py-1" style={{ width: "30%" }}>{item.description || "-"}</span>
                <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "25%" }}>{item.payment_type || "-"}</span>
                <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "20%" }}>{item.type || "-"}</span>
                <span className="px-1 py-1 text-right" style={{ width: "25%" }}>{formatPrice(item.amount)}</span>
              </p>
            );
          }) : (
            <p className="mb-0 border border-dark border-top-0 text-center py-1">No data</p>
          )}
          <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Total</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{reportData?.total ? reportData.total : "0.00"}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BranchExpenseReport;
